import { render } from "./IssuesForm.vue?vue&type=template&id=2d1edc6e"
import script from "./IssuesForm.vue?vue&type=script&lang=js"
export * from "./IssuesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__